import { render, staticRenderFns } from "./UnregisteredProduct.vue?vue&type=template&id=27428c48&"
import script from "./UnregisteredProduct.vue?vue&type=script&lang=js&"
export * from "./UnregisteredProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports